import { NestedTreeControl } from '@angular/cdk/tree'
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { MatTableDataSource } from '@angular/material/table'
import { MatTreeNestedDataSource } from '@angular/material/tree'
import { ActivatedRoute, Router } from '@angular/router'
import * as moment from 'moment'
import { Observable, Subscription, of } from 'rxjs'
import { debounceTime, filter, map } from 'rxjs/operators'
import { AuthorizationService } from '../../access/shared/authorization/authorization.service'
import { Permissions } from '../../access/shared/authorization/permissions'
import { CommandeService } from '../linge-hebergement/shared/commande.service'
import { Client } from '../shared/client/client'
import { ClientService } from '../shared/client/client.service'
import { SideBarComponent } from '../shared/sidebar/side-bar-component'
import { SideBarService } from '../shared/sidebar/side-bar.service'
import { StatsColumn } from './shared/stats/stats-column'
import { statsColums } from './shared/stats/stats-columns-data'
import { StatsService } from './shared/stats/stats.service'
import { MatDialog } from '@angular/material/dialog'
import { StatisticLavageHelpComponent } from './statistic-lavage-help/statistic-lavage-help.component'

interface DataNode {
    lingerie?: string
    children?: any
    data?: any
}

@Component({
    selector: 'app-statistic',
    templateUrl: './statistic.component.html',
    styleUrls: ['./statistic.component.scss']
})
export class StatisticComponent extends SideBarComponent implements OnInit, OnDestroy {
    // Définition des colonnes à afficher
    displayedColumns: Map<string, Array<string>> = new Map<string, Array<string>>([
        ['stock', ['TAI_UTL', 'UTL_LIB', 'TAI_CLF', 'TAI_COD', 'ART_DES', 'TAI_TAI', 'TAI_STS', 'TAI_STC']],
        ['porteur', ['numPorteur', 'porteur', 'casier', 'codeArticle', 'designation', 'taille', 'dateDernierLavage', 'action', 'cabJeu', 'cabNum']],
        ['rotation', ['codeArticle', 'libelleArticle', 'qt_sem', 'tx_rot', 'qt_sem_5_traitees', 'qt_mab', 'qt_theo', 'stock', 'qt_diff']],
        ['5-last-cleaning', ['numPorteur', 'porteur', 'cabNum', 'codeArticle', 'designation', 'casier', 'taille', 'cabJeu', 'nbLavages', 'lavage_0', 'lavage_1', 'lavage_2', 'lavage_3', 'lavage_4']],
        ['cab-db-integrity', ['numPorteur', 'porteur', 'cabNum', 'codeArticle', 'designation', 'casier', 'taille', 'cabEtat']],
        ['conso-history', ['type', 'ligne', 'regleFacturation', 'codeArticle', 'designationArticle', 'dateM', 'quantite']]
    ])
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>()
    coefRotation: number
    dateArrete
    recap: Array<Object> = []
    columns: Array<StatsColumn> = new Array<StatsColumn>()
    completeTable: Array<Object> = []
    searchText
    sub: Subscription = new Subscription()
    clientLoad: Subscription = new Subscription()
    canExport = true
    tofilter: any
    active: string
    filterControl: FormControl = new FormControl('', [Validators.required, Validators.minLength(3)])
    load = true
    input_hint: String = 'Min. 3 caractères'
    filter
    loadButton = false
    searchByName = false
    radioControl: FormControl = new FormControl(false)
    labelSiVide: String
    placeholder = 'Rechercher par utilisateur/motif/numéro de demande'
    loading: boolean = false
    loadingSpecial: boolean = false

    subClient: Subscription

    dateDebut: FormControl
    dateFin: FormControl
    periodGroup = ["Mois", "Trimestre", "Semestre", "Année"]
    period: FormControl = new FormControl({ value: this.periodGroup[0], disabled: true }, [Validators.required])
    radioConso: FormControl = new FormControl({ value: true, disabled: true })
    groupLingerie: FormControl = new FormControl({ value: false, disabled: true })
    dataStatsList = [{ id: "brut", libelle: "Globales", texte: "" }]
    dataStats: FormControl = new FormControl(this.dataStatsList[0], [Validators.required])

    lingerieActivated
    qteArticles
    qteDispatch
    listMois = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"]
    periods
    periodsDispatch
    data
    dataDispatch
    options
    optionsDispatch
    colors = [
        '#7bcced', '#93d3c1', '#d8d07f', '#b3cd73', '#fabe77', '#f6a39d', '#f467ad', '#ccaec9',
        '#87D0D7', '#B6D2A0', '#C6CF79', '#D7C675', '#F8B18A', '#F585A5', '#E08BBB', '#A4BDDB',
        '#9FD1BC', '#BED18D', '#CFCB77', '#E8BC80', '#F79B98', '#EB88B0', '#C2A4CB', '#96C7D9'
    ]
    treeControl = new NestedTreeControl<DataNode>(node => node.data)
    dataLingeries = new MatTreeNestedDataSource<DataNode>()
    currentClient
    isLHActivated = new FormControl(false)

    /**
     *
     * @param authorization
     * @param statsService
     * @param route
     * @param router
     * @param sideBar
     * @param $gaService
     * @param clientService
     */
    constructor(
        private authorization: AuthorizationService,
        private statsService: StatsService,
        protected route: ActivatedRoute,
        protected router: Router,
        private sideBar: SideBarService,
        private clientService: ClientService,
        private commandeService: CommandeService,
        private cdr: ChangeDetectorRef,
        private dialog: MatDialog
    ) {
        super(sideBar, router, route)

        let first = (new Date().getMonth() + 12 - 2) % 12 + 1;
        this.dateDebut = new FormControl({ value: moment(new Date(first + "/01/" + (first > 10 ? new Date().getFullYear() - 1 : new Date().getFullYear()))), disabled: true }, [Validators.required])
        this.dateFin = new FormControl({ value: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)), disabled: true }, [Validators.required])
    }

    hasChild = () => true

    getType(element, column): string {
        if (column.type !== undefined) {
            return column.type
        } else {
            return typeof element[column.id]
        }
    }

    ngOnInit() {
        this.filterControl.markAsTouched({ onlySelf: true })
        super.ngOnInit()
        this.columns = statsColums
        this.active = this.route.snapshot.data.stats
        this.loadButton = this.route.snapshot.data.loadButton === true
        this.searchByName = this.route.snapshot.data.searchByName

        this.subClient = this.clientService.getCurrentClient().subscribe(client => {
            this.lingerieActivated = client.is_comptage_lingerie || !client.is_livraison_commande
            this.currentClient = client

            if (this.authorization.hasPermission(Permissions.ROLE_ANETT)) {
                this.displayedColumns = new Map<string, Array<string>>([
                    ['stock', ['TAI_UTL', 'UTL_LIB', 'TAI_CLF', 'TAI_COD', 'ART_DES', 'TAI_TAI', 'TAI_QTP', 'TAI_STC', 'TAI_QTS', 'TAI_STS', 'TAI_REG']],
                    ['porteur', ['numPorteur', 'porteur', 'casier', 'codeArticle', 'designation', 'taille', 'dateDernierLavage', 'action', 'cabJeu', 'cabNum']],
                    ['rotation', ['codeArticle', 'libelleArticle', 'qt_sem', 'tx_rot', 'qt_sem_5_traitees', 'qt_mab', 'qt_theo', 'stock', 'qt_diff']],
                    ['5-last-cleaning', ['numPorteur', 'porteur', 'cabNum', 'codeArticle', 'designation', 'casier', 'taille', 'cabJeu', 'nbLavages', 'lavage_0', 'lavage_1', 'lavage_2', 'lavage_3', 'lavage_4']],
                    ['cab-db-integrity', ['numPorteur', 'porteur', 'cabNum', 'codeArticle', 'designation', 'casier', 'taille', 'cabEtat']],
                    ['conso-history', ['type', 'ligne', 'regleFacturation', 'codeArticle', 'designationArticle', 'dateM', 'quantite']]
                ])
            }
            if (this.active === 'rotation') {
                this.initRotation()
            } else if (this.active === 'porteur' || this.active === 'stock' || this.active === '5-last-cleaning') {
                this.initDefault()
            } else if (this.active === 'conso-history') {
                this.initConsoHistory()
            } else if (this.active === 'cab-db-integrity') {
                this.initIntegrity()
            } else if (this.active === 'linge-hebergement') {
                const documentStyle = getComputedStyle(document.documentElement)
                const surfaceBorder = documentStyle.getPropertyValue('--surface-border')

                this.options = {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'bottom',
                            labels: {
                                usePointStyle: true,
                                boxHeight: 10
                            }
                        }
                    },
                    scales: {
                        x: {
                            stacked: true,
                            grid: {
                                color: surfaceBorder,
                                drawBorder: false
                            }
                        },
                        y: {
                            stacked: true,
                        }
                    }
                }
                this.initGraphique()
                this.isLingeHebergementActivated(client)
                this.generateOptions()

                if (!this.currentClient.is_livraison_commande) {
                    this.optionsDispatch = {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: {
                                callbacks: {
                                    label: function (context) {
                                        return Math.round(context.parsed.y * 100) / 100 + ' %';
                                    }
                                }
                            }
                        },
                        scales: {
                            x: {
                                stacked: true,
                                grid: {
                                    color: surfaceBorder,
                                    drawBorder: false
                                }
                            },
                            y: {
                                stacked: true,
                                ticks: {
                                    callback: function (value) {
                                        return value + ' %';
                                    }
                                }
                            }
                        }
                    }
                }
            }
        })
    }

    ngOnDestroy() {
        if (this.subClient) {
            this.subClient.unsubscribe()
        }
        this.sub.unsubscribe()
        this.clientLoad.unsubscribe()
    }

    private initConsoHistory() {
        this.getStats('')
    }

    private initRotation() {
        this.getStats('')
    }

    private initDefault() {
        this.placeholder = 'Veuillez effectuer votre recherche'
        this.filterControl.valueChanges.pipe(debounceTime(300), filter(val => val != null)).subscribe(val => {
            this.load = true
            if (val.length > 2 && this.radioControl.value === false) {
                this.getStats(val)
            } else if (val.length > 0 && this.radioControl.value === true) {
                this.getStats(val)
            } else {
                this.dataSource.data = new Array<Object>()
                this.completeTable = new Array<Object>()
            }
        })

        this.radioControl.valueChanges.subscribe(value => {
            this.dataSource.data = new Array<Object>()
            this.completeTable = new Array<Object>()

            if (value === false) {
                this.input_hint = 'Min. 3 caractères'
                this.filterControl.setValidators([Validators.required, Validators.minLength(3)])
            } else {
                this.input_hint = ''
                this.filterControl.setValidators([Validators.required])
            }
            this.filterControl.updateValueAndValidity();
        })
    }

    private initIntegrity() {
        this.filterControl.valueChanges.pipe(debounceTime(300), filter(val => val != null)).subscribe(val => {
            if (val.length > 2 && this.radioControl.value === false) {
                this.getStats(val)
            } else if (val.length > 0 && this.radioControl.value === true) {
                this.getStats(val)
            }
        })

        this.radioControl.valueChanges.subscribe(value => {
            if (value === false) {
                this.input_hint = 'Min. 3 caractères'
                this.filterControl.setValidators([Validators.required, Validators.minLength(3)])
            } else {
                this.input_hint = ''
                this.filterControl.setValidators([Validators.required])
            }
            this.filterControl.updateValueAndValidity();
        })
    }

    private loadData(filterType: string, filterContent: string): Observable<Array<Object>> {
        switch (this.active) {
            case 'stock': return this.statsService.getStock(this.currentClient, filterType, filterContent)
            case 'porteur': return this.statsService.getPorteurs(this.currentClient, filterType, filterContent)
            case 'cab-db-integrity': return this.statsService.getCabDBIntegrity(this.currentClient, filterType, filterContent)
            case 'conso-history': return this.statsService.getConsoHistory(this.currentClient).pipe(map(
                data => {
                    if (data) {
                        data = data.map(function (el) {
                            el['dateM'] = moment(el['date']).format('DD/MM/Y')
                            return el
                        })
                        return data
                    }
                }
            ))
            case '5-last-cleaning': return this.statsService.getLastCleaning(this.currentClient, filterType, filterContent)
            case 'rotation': return this.statsService.getRotations(this.currentClient).pipe(map(
                data => {
                    if (data) {
                        data.sort((a, b) => a['codeArticle'].toString().localeCompare(b['codeArticle']))
                        this.coefRotation = data[0]['coefRotation']
                        this.dateArrete = data[0]['dateArrete']
                        data = data.map(function (el) {
                            el['qt_sem_1_traitees'] = el['qt_sem_5_traitees'][0]
                            el['qt_sem_2_traitees'] = el['qt_sem_5_traitees'][1]
                            el['qt_sem_3_traitees'] = el['qt_sem_5_traitees'][2]
                            el['qt_sem_4_traitees'] = el['qt_sem_5_traitees'][3]
                            el['qt_sem_5_traitees'] = el['qt_sem_5_traitees'][4]
                            return el
                        })
                        return data
                    }
                }
            ))
            default: return of(new Array<Object>())
        }
    }

    private getFilterType(filterContent: string): string {
        if (this.radioControl.value) { return 'casier' }
        return filterContent.match(/^\d+$/) !== null ? 'id' : 'name'
    }


    getStats(filterContent: string, special: boolean = false) {
        this.loading = true
        this.loadingSpecial = special
        this.sub.unsubscribe()
        this.canExport = false
        this.sub = this.loadData(this.getFilterType(filterContent), filterContent).subscribe(data => {
            if (data) {
                this.setPartialTable(data)
                this.completeTable = data
            } else {
                this.completeTable = []
                this.dataSource.data = []
                this.recap = []
            }
            this.load = false
            this.loading = false
            this.loadingSpecial = false
            this.canExport = true
        }, error => {
            this.loading = false
            this.loadingSpecial = false
        })
    }

    setCompleteTable() {
        this.dataSource.data = this.completeTable
    }

    /**
     *
     * @param data
     */
    setPartialTable(data: Array<Object>) {
        this.dataSource.data = data.slice(0, 7)
    }

    /**
     *
     * @returns {Promise<void>}
     */
    export() {
        if (this.active == 'linge-hebergement') {
            this.exportLingeHebergement()
        } else {
            return this.router.navigate([{
                outlets: {
                    sidebar: ['export']
                }
            }], {
                relativeTo: this.route,
                skipLocationChange: true,
            }).then(() => this.sideBar.toggle(), err => console.log(err))
        }
    }

    exportLingeHebergement() {
        let filter = { dateDebut: this.dateDebut.value.format('DD/MM/YYYY'), dateFin: this.dateFin.value.format('DD/MM/YYYY'), group: this.period.value, groupLingerie: this.groupLingerie.value }

        this.statsService.exportLingeHebergementOfCurrentClient(filter).subscribe(response => this.loading = false, error => this.loading = false)
    }

    get filterContent() {
        return this.filterControl.value
    }

    initGraphique() {
        this.isLHActivated.valueChanges.pipe(debounceTime(300), filter(val => val != null)).subscribe(val => {
            if (!val) {
                this.dateDebut.disable({ emitEvent: false })
                this.dateFin.disable({ emitEvent: false })
                this.period.disable({ emitEvent: false })
                this.radioConso.disable({ emitEvent: false })
                this.groupLingerie.disable({ emitEvent: false })
            } else {
                this.dateDebut.enable({ emitEvent: false })
                this.dateFin.enable({ emitEvent: false })
                this.period.enable({ emitEvent: false })
                this.radioConso.enable({ emitEvent: false })
                this.groupLingerie.enable({ emitEvent: false })
            }
            this.getDatas(this.currentClient)
        })
        this.dateDebut.valueChanges.pipe(debounceTime(300), filter(val => val != null)).subscribe(val => {
            this.getDatas(this.currentClient)
        })
        this.dateFin.valueChanges.pipe(debounceTime(300), filter(val => val != null)).subscribe(val => {
            this.getDatas(this.currentClient)
        })
        this.period.valueChanges.pipe(debounceTime(300), filter(val => val != null)).subscribe(val => {
            this.getDatas(this.currentClient)
        })
        this.groupLingerie.valueChanges.pipe(debounceTime(300), filter(val => val != null)).subscribe(val => {
            this.getDatas(this.currentClient)
            if (!this.currentClient.is_livraison_commande && this.groupLingerie.value) {
                this.getDatasDispatch(this.currentClient)
            }
        })
        this.radioConso.valueChanges.pipe(debounceTime(300), filter(val => val != null)).subscribe(val => {
            this.createChartColumn(this.dataStats.value);
        })
        this.dataStats.valueChanges.subscribe(value => {
            this.createChartColumn(this.dataStats.value)
        })
    }

    getDatas(client: Client) {
        if (this.isLHActivated.value) {
            this.loading = true

            let filter = { dateDebut: this.dateDebut.value.format('DD/MM/YYYY'), dateFin: this.dateFin.value.format('DD/MM/YYYY'), group: this.period.value, isConso: this.radioConso.value, groupLingerie: this.groupLingerie.value }
            this.statsService.getStatsLingeHebergement(client, filter).subscribe(list => {
                this.qteArticles = list['datas']
                this.periods = list['period']
                this.createChartColumn(this.dataStats.value)
                this.loading = false
            }, error => this.loading = false)
        }
    }

    getDatasDispatch(client: Client) {
        let filter = { dateDebut: this.dateDebut.value.format('DD/MM/YYYY'), dateFin: this.dateFin.value.format('DD/MM/YYYY'), group: this.period.value }
        this.statsService.getStatsLHDispatch(client, filter).subscribe(list => {
            this.qteDispatch = list['datas'].qteValidees.map((qteValidees, index) => {
                const qteDispatch = list['datas'].qteDispatch[index] ?? 0;

                return qteValidees > 0
                    ? (qteDispatch / qteValidees) * 100
                    : 0;
            });
            this.periodsDispatch = list['period']
            this.createChartColumnDispatch()
            this.loading = false
        })
    }

    createChartColumn(selectData): void {
        this.loading = true
        if (this.groupLingerie.value) {
            this.dataLingeries.data = []
            let datas = []

            this.qteArticles.forEach(lingerie => {
                let periodsLabel = this.periods.map(value => value.label)
                if (selectData.id == 'jours' || selectData.id == 'nuits') {
                    periodsLabel = this.periods.map(value => {
                        let found = value.stats.filter(value => value.lingerieId == lingerie.lingerieId)
                        let nbJours = found.length > 0 ? found[0].jours : 0
                        return value.label + ' (' + nbJours + ' ' + selectData.id + ')'
                    })
                } else if (selectData.id == 'chambres' || selectData.id == 'lits') {
                    periodsLabel = this.periods.map(value => {
                        let found = value.stats.filter(value => value.lingerieId == lingerie.lingerieId)
                        let nbEmplacements = found.length > 0 ? found[0].emplacements : 0
                        return value.label + ' (' + nbEmplacements + ' ' + selectData.id + ')'
                    })
                }

                const dataset = []
                let index = 0

                lingerie.datas.forEach(article => {
                    if (selectData.id == 'jours' || selectData.id == 'nuits') {
                        dataset.push({
                            type: 'bar',
                            label: article['article']['designation'],
                            data: this.radioConso.value ? article['quantiteJour'] : article['coutJour'],
                            backgroundColor: this.colors[index % this.colors.length]
                        })
                    } else if (selectData.id == 'chambres' || selectData.id == 'lits') {
                        dataset.push({
                            type: 'bar',
                            label: article['article']['designation'],
                            data: this.radioConso.value ? article['quantiteEmplacement'] : article['coutEmplacement'],
                            backgroundColor: this.colors[index % this.colors.length]
                        })
                    } else {
                        dataset.push({
                            type: 'bar',
                            label: article['article']['designation'],
                            data: this.radioConso.value ? article['quantite'] : article['cout'],
                            backgroundColor: this.colors[index % this.colors.length]
                        })
                    }
                    index++
                })

                let data = {
                    labels: periodsLabel,
                    datasets: dataset,
                    empty: this.emptyStatsLingeHebergement(dataset),
                }

                datas.push({ lingerie: { nom: lingerie.lingerie, types: lingerie.types }, data: data })
            })
            datas.sort((a, b) => a.lingerie.nom > b.lingerie.nom ? 1 : -1)
            this.dataLingeries.data = [...datas];
            this.treeControl.dataNodes = this.dataLingeries.data;
            this.cdr.detectChanges()
        } else {
            let periodsLabel = this.periods.map(value => value.label)
            if (selectData.id == 'jours' || selectData.id == 'nuits') {
                periodsLabel = this.periods.map(value => value.label + ' (' + value.stats.jours + ' ' + selectData.id + ')')
            } else if (selectData.id == 'chambres' || selectData.id == 'lits') {
                periodsLabel = this.periods.map(value => value.label + ' (' + value.stats.emplacements + ' ' + selectData.id + ')')
            }

            const dataset = []
            let index = 0

            this.qteArticles.forEach(article => {
                if (selectData.id == 'jours' || selectData.id == 'nuits') {
                    dataset.push({
                        type: 'bar',
                        label: article['article']['designation'],
                        data: this.radioConso.value ? article['quantiteJour'] : article['coutJour'],
                        backgroundColor: this.colors[index % this.colors.length]
                    })
                } else if (selectData.id == 'chambres' || selectData.id == 'lits') {
                    dataset.push({
                        type: 'bar',
                        label: article['article']['designation'],
                        data: this.radioConso.value ? article['quantiteEmplacement'] : article['coutEmplacement'],
                        backgroundColor: this.colors[index % this.colors.length]
                    })
                } else {
                    dataset.push({
                        type: 'bar',
                        label: article['article']['designation'],
                        data: this.radioConso.value ? article['quantite'] : article['cout'],
                        backgroundColor: this.colors[index % this.colors.length]
                    })
                }
                index++
            })

            this.data = {
                labels: periodsLabel,
                datasets: dataset,
                empty: this.emptyStatsLingeHebergement(dataset)
            }
        }
        this.loading = false
    }

    createChartColumnDispatch(): void {
        this.loading = true
        let periodsLabel = this.periodsDispatch.map(value => value.label)

        const datasetDispatch = []

        datasetDispatch.push({
            type: 'bar',
            data: this.qteDispatch,
            backgroundColor: this.colors[1]
        })

        this.dataDispatch = {
            labels: periodsLabel,
            datasets: datasetDispatch,
            empty: datasetDispatch.length == 0
        }
        this.loading = false
    }

    emptyStatsLingeHebergement(datas) {
        let empty = true
        datas.forEach(article => {
            if (!article.data.every(item => item == 0)) {
                empty = false
                return
            }
        })
        return empty
    }

    statsLH() {
        this.router.navigate(['/escli/statistic/stats-LH/gestion']);
    }

    isLingeHebergementActivated(client) {
        if (!this.currentClient.is_livraison_commande || this.currentClient.is_comptage_lingerie) {
            this.commandeService.getClientDotations(this.currentClient.id).subscribe(data => {
                if (data.length > 0) {
                    this.isLHActivated.setValue(true)
                } else {
                    this.isLHActivated.setValue(false)
                }
            })
        } else {
            this.isLHActivated.setValue(this.currentClient && (this.currentClient.is_livraison_commande && !this.currentClient.is_comptage_lingerie));
        }
    }

    generateOptions() {
        // Génération des options pour affichage
        let isSante = (this.currentClient.famille_client.cle_ref == '700' || this.currentClient.famille_client.parent?.cle_ref == '700')
        let isHotel = (this.currentClient.famille_client.cle_ref == '600' || this.currentClient.famille_client.parent?.cle_ref == '600')

        if (isHotel) {
            this.dataStatsList.push({ id: "chambres", libelle: "Par chambre", texte: "par chambre" })
            this.dataStatsList.push({ id: "nuits", libelle: "Par nuitée", texte: "par nuitée" })
        } else {
            if (isSante) {
                this.dataStatsList.push({ id: "lits", libelle: "Par lit", texte: "par lit" })
            }
            this.dataStatsList.push({ id: "jours", libelle: "Par jour d'activité", texte: "par jour d'activité" })
        }
    }

    getDataLingeries() {
        return this.dataLingeries
    }

    help() {
        this.dialog.open(StatisticLavageHelpComponent)
    }
}
